import { Box, Typography } from '@mui/material';
import TableContainer from 'src/components/Table/TableContainer';

// `fill` makes the card grow to its flex row's height instead of its own content's, so cards drawn
// side by side line up on whichever has the most rows. The shorter one gains blank space under its
// last row rather than stretching the rows themselves. `minHeight` only keeps a nearly empty pair
// from collapsing; it is not what makes them match.
const TableCard = ({
  title,
  subtitle,
  maxHeight = 400,
  minHeight,
  fill = false,
  edgePadding = 3,
  children,
}) => (
  <Box
    sx={{
      backgroundColor: '#484848',
      borderRadius: 1,
      overflow: 'hidden',
      boxShadow: '0px 1px 2px 0px #64748B1A',
      ...(fill ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 } : {}),
      '& th:first-of-type, & td:first-of-type': {
        paddingLeft: theme => theme.spacing(edgePadding),
      },
      '& th:last-of-type, & td:last-of-type': {
        paddingRight: theme => theme.spacing(edgePadding),
      },
    }}>
    <Box sx={{ px: edgePadding, pt: edgePadding, pb: 1.5 }}>
      <Typography variant="subtitle2">{title}</Typography>
      {subtitle ? (
        <Typography sx={{ color: '#9CA3AF', fontSize: '0.7rem' }}>{subtitle}</Typography>
      ) : null}
    </Box>
    <TableContainer
      styles={{
        maxHeight,
        ...(minHeight ? { minHeight } : {}),
        ...(fill ? { flex: 1 } : {}),
      }}>
      {children}
    </TableContainer>
  </Box>
);

export default TableCard;
